import { createFileRoute } from "@tanstack/react-router";
import { ScribePage } from "shared/components/global/Scribe/ScribePage";

/** @public */
export const Route = createFileRoute("/_auth/help/ipaws")({
    component: () => <ScribePage src="https://scribehow.com/page-embed/IPAWS__Vief4BIxRymKKmCEhPQlxA" />,
});
